import React, { createContext, useContext, useEffect } from 'react';

const ThemeContext = createContext();

// App is light-only. Kept for API compatibility with existing screens.
export const ThemeProvider = ({ children }) => {
  const setMode = () => {};
  return <ThemeContext.Provider value={{ mode: 'light', setMode, isDark: false }}>{children}</ThemeContext.Provider>;
};

// Always render in light mode (remove any 'dark' class).
export const ThemeApplier = () => {
  useEffect(() => {
    document.documentElement.classList.remove('dark');
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute('content', '#ffffff');
  });
  return null;
};

export const useTheme = () => useContext(ThemeContext);
